import React from "react";
import PropTypes from "prop-types";
import { I18n } from "@aws-amplify/core";
import { get, filter, map, sortBy } from "lodash";

import Grid from "@material-ui/core/Grid";

import ProfileSurveyQuestion from "./ProfileSurveyQuestion";
import ProfileSurveyQuestionNew from "./ProfileSurveyQuestionNew";
import InfoSection from "../../Common/InfoSection";

import { LANGUAGES } from "../../../constants/common";

import { formatDate } from "../../../utils/date";

const ProfileSurveyView = (props) => {
  const { survey, verification, language, audio } = props;

  if (!survey || !get(survey, ["attributes"])) {
    return <></>;
  }

  const attr151 = get(
    filter(get(survey, ["attributes"]), (attr) => attr.id === 151),
    [0]
  );

  return (
    <Grid container direction="column">
      <Grid item style={{ height: "54px" }}>
        <Grid container wrap="nowrap">
          <Grid item xs={6}>
            <InfoSection
              title={"location"}
              values={[
                get(survey, ["zone"])
                  ? `${get(survey, ["zone", "site", "name"])} - ${get(survey, [
                      "zone",
                      "name",
                    ])}`
                  : I18n.get("profiles_online"),
              ]}
            />
          </Grid>
          <Grid item xs={6}>
            <InfoSection
              title={"dateTime"}
              values={[formatDate(get(survey, ["created_on"]))]}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        {verification
          ? map(
              sortBy(verification, (item) => item.sequence),
              (item, index) => (
                <ProfileSurveyQuestionNew
                  key={index}
                  item={item}
                  surveyType={get(survey, ["type", "id"])}
                  attr151={attr151}
                  language={language}
                  audio={filter(
                    audio,
                    (i) => get(i, ["sequence"]) === get(item, ["sequence"])
                  )}
                />
              )
            )
          : map(
              sortBy(
                filter(
                  get(survey, ["attributes"]),
                  (attr) => attr.app_display_main_page
                ),
                (attr) => attr.app_display_seq_numb
              ),
              (attr, index) => (
                <ProfileSurveyQuestion
                  key={attr.id}
                  surveyType={get(survey, ["type", "id"])}
                  question={attr}
                  index={index}
                  language={language}
                  attr151={attr151}
                  audio={filter(
                    audio,
                    (item) => get(item, ["sys_attribute_id"]) === attr.id
                  )}
                />
              )
            )}
      </Grid>
    </Grid>
  );
};

ProfileSurveyView.propTypes = {
  title: PropTypes.string,
  survey: PropTypes.object,
  language: PropTypes.oneOf(LANGUAGES),
};

export default ProfileSurveyView;
